export default __webpack_public_path__ + "static/logo-5c38c9d7437ed297eb279724561818ec.png";